export default {
  chargeScene: {
    stats: {
      totalCount: '场景总数',
      virtualCount: '虚拟场景',
      physicalCount: '实体场景',
      disabledCount: '已停用',
    },
    loadingTypes: '正在加载场景类型...',
    table: {
      title: '扣费场景列表',
      sceneCode: '场景编码',
      sceneName: '场景名称',
      chargeRule: '扣费规则',
      sceneType: '场景类型',
      sceneForm: '场景形态',
      shopName: '归属门店',
      ruleId: '关联扣费规则',
      pointCount: '点位数量',
      bindingDeviceCount: '绑定设备',
      status: '状态',
      createTime: '创建时间',
      action: '操作',
    },
    search: {
      keyword: '关键词',
      keywordPlaceholder: '场景名称/编码',
      shopName: '归属门店',
      sceneForm: '场景形态',
      status: '状态',
    },
    sceneForm: {
      virtual: '虚拟场景',
      physical: '实体场景',
    },
    status: {
      enabled: '启用',
      disabled: '停用',
    },
    unit: {
      pointCount: '{count} 个',
      deviceCount: '{count} 台',
    },
    action: {
      add: '新增扣费场景',
      detail: '详情',
      binding: '绑定设备',
      rule: '关联扣费规则',
      edit: '编辑',
      enable: '启用',
      disable: '停用',
      delete: '删除',
      refresh: '刷新',
    },
    form: {
      addTitle: '新增扣费场景',
      editTitle: '编辑扣费场景',
      sceneName: '场景名称',
      sceneNamePlaceholder: '请输入场景名称',
      sceneCode: '场景编码',
      sceneCodePlaceholder: '保存后自动生成',
      sceneType: '场景类型',
      sceneTypePlaceholder: '请选择场景类型',
      pointCount: '点位数量',
      pointCountHint: '保存后自动生成 P01、P02...；已有绑定或扣费记录的点位不能直接删除。',
      sceneForm: '场景形态',
      sceneFormHint: '由场景类型自动判断，不支持单独选择。',
      status: '启用状态',
      statusPlaceholder: '请选择启用状态',
      shopName: '归属门店',
      shopPlaceholder: '请选择门店',
      shopRequired: '请选择门店',
      remark: '备注',
      remarkPlaceholder: '请输入备注',
      cancel: '取消',
      saveEdit: '保存修改',
      saveAdd: '保存场景',
      sceneNameRequired: '请输入场景名称',
      sceneTypeRequired: '请选择场景类型',
      pointCountRequired: '请输入点位数量',
      pointCountRange: '点位数量必须在 1 到 99 之间',
      statusRequired: '请选择启用状态',
      unsavedTitle: '未保存修改',
      unsavedMessage: '当前内容尚未保存，确定关闭吗？',
    },
    rule: {
      addTitle: '新增扣费规则',
      editTitle: '编辑扣费规则',
      ruleSource: '规则来源',
      ruleNoPlaceholder: '请输入规则编号',
      saveRule: '保存规则',
      ruleNoInvalid: '规则编号仅支持1-64位字母或数字',
      ruleNameTooLong: '规则名称不能超过64个字符',
      editOwnStoreOnly: '门店只能编辑自己门店创建的扣费规则',
      deleteConfirm: '确定要删除规则「{name}」吗？',
      title: '关联扣费规则',
      close: '关闭',
      keyword: '关键词',
      keywordPlaceholder: '规则名称 / 规则编号',
      sceneName: '场景名称',
      shopName: '归属门店',
      current: '当前规则',
      ruleNo: '规则编号',
      ruleName: '规则名称',
      ruleNamePlaceholder: '请输入规则名称',
      chargeAssets: '扣费资产',
      shopScope: '适用门店',
      status: '启用状态',
      search: '查询',
      select: '选择规则',
      clear: '取消关联',
      clearTitle: '取消关联确认',
      clearConfirm: '确定取消当前扣费场景的规则关联吗？',
      unlinked: '暂无关联',
      unlinkedHint: '保存后场景下全部点位暂不能发起扣费',
      unlinkedStatus: '未关联',
      allShops: '全部门店',
      empty: '暂无可关联的扣费规则',
      loadFailed: '扣费规则查询失败，请重试',
      invalidSceneId: '扣费场景信息无效，无法保存规则关联',
      cancel: '取消',
      save: '保存',
      saved: '扣费规则关联保存成功',
    },
    detail: {
      title: '扣费场景详情',
      sceneCode: '场景编码',
      sceneName: '场景名称',
      sceneType: '场景类型',
      sceneForm: '场景形态',
      shopName: '归属门店',
      ruleName: '关联规则',
      pointCount: '点位数量',
      bindingDeviceCount: '绑定设备',
      createTime: '创建时间',
      remark: '备注',
      status: '状态',
      close: '关闭',
    },
    point: {
      title: '{name}｜点位明细',
      count: '点位数量：{count}',
      adjustCount: '调整点位数量',
      pointName: '点位名称',
      pointCode: '点位编码',
      bindingDeviceCount: '绑定设备',
      boundDeviceCount: '已绑定{count}台',
      ruleName: '生效扣费规则',
      status: '状态',
      action: '操作',
      binding: '绑定设备',
      close: '关闭',
      adjustTitle: '调整点位数量',
      cancel: '取消',
      save: '保存',
      countUpdated: '点位数量更新成功',
      enableTitle: '确认启用扣费点位',
      enableMessage: '启用后，“{sceneName} / {pointName}”恢复可用；仍需扣费场景启用并关联扣费规则，才能发起扣费。不影响同场景其他点位。',
      disableTitle: '确认停用扣费点位',
      disableMessage: '停用后，“{sceneName} / {pointName}”不能继续发起扣费，不影响同场景其他点位。',
      statusUpdated: '点位状态更新成功',
    },
    binding: {
      title: '{sceneName} / {pointCode} | 绑定设备',
      summary: '{sceneName} / {pointCode}，可绑定设备 {count} 台',
      readShop: '读取设备门店：',
      shopScopeHint: '仅展示该门店下可绑定的收银台、卡头和扣费桩',
      availableTitle: '可绑定设备',
      description: '正在配置{sceneName} / {pointCode}；卡头只能绑定一个点位，已被同门店其他扣费场景或点位绑定的卡头不可选择；收银台和扣费桩可多选。',
      deviceCodePlaceholder: '设备编码：请输入',
      deviceNamePlaceholder: '设备名称：请输入',
      reset: '重置',
      search: '查询',
      allDevices: '全部设备',
      cashier: '收银台',
      card: '卡头',
      chargePile: '扣费桩',
      deviceSummary: '共 {total} 台设备，{available} 台可选',
      selectedSummary: '当前点位已选 {count} 台',
      boundTo: '已绑定：{name}',
      empty: '暂无符合条件的设备',
      keywordPlaceholder: '设备编码/名称',
      typePlaceholder: '设备类型',
      allTypes: '全部类型',
      deviceCode: '设备编码',
      deviceName: '设备名称',
      deviceType: '设备类型',
      bindingStatus: '绑定状态',
      currentPoint: '当前点位',
      otherPoint: '其他点位',
      unbound: '未绑定',
      deviceStatus: '设备状态',
      close: '取消',
      save: '保存',
      saved: '设备绑定保存成功',
    },
    bindingDetail: {
      title: '已绑定设备详情',
      summary: '已绑定 {count} 台设备',
      batchUnbind: '批量解绑',
      pointCode: '点位',
      deviceCode: '设备编码',
      deviceName: '设备名称',
      deviceType: '设备类型',
      unbind: '解绑',
      close: '关闭',
      missingPoint: '未找到设备所属点位',
      unbindConfirm: '确认解除“{deviceName}”与“{sceneName} / {pointName}”的绑定关系吗？解绑后，该点位将不能再通过此设备发起扣费。',
      unbindTitle: '确认解绑设备',
      batchConfirm: '确认解除已选的 {count} 条设备绑定关系吗？解绑后，相关点位将不能再通过这些设备发起扣费，未勾选的绑定关系不受影响。',
      batchTitle: '确认批量解绑设备',
      unbindSuccess: '解绑成功',
      batchSuccess: '批量解绑成功',
      batchResult: '解绑成功 {success} 条，失败 {failed} 条',
    },
    confirm: {
      enableTitle: '确认启用扣费场景',
      enableMessage: '启用后，“{sceneName}”下状态为启用的点位恢复可用，未关联扣费规则时仍不能发起扣费，且启用期间不可编辑或删除扣费场景。',
      disableTitle: '确认停用扣费场景',
      disableMessage: '停用后，“{sceneName}”及其全部点位不能继续发起扣费，已产生的扣费记录不受影响。停用后可编辑或删除该扣费场景。',
      deleteTitle: '确认删除扣费场景',
      deleteMessage: '删除后，“{sceneName}”及其点位将从扣费场景列表移除，已有设备绑定和扣费规则关联同时解除；历史扣费记录仍保留用于追溯。此操作不可撤销。',
    },
    message: {
      added: '新增成功',
      edited: '编辑成功',
      deleted: '删除成功',
      statusEnabled: '启用成功',
      statusDisabled: '停用成功',
      ruleApiUnavailable: '当前后端暂未提供关联扣费规则接口',
    },
    notLinked: '未关联',
  },
};
